import React from 'react';
import { User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDate } from './helpers';

export const ReporterInfoCard = ({ report }) => (
  <>
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="w-5 h-5" />
          Denunciante
        </CardTitle>
      </CardHeader>
      <CardContent>
        {report.is_anonymous ? (
          <Badge variant="outline">Anónimo</Badge>
        ) : (
          <div className="space-y-2 text-sm">
            {report.reporter_name && <p><strong>Nome:</strong> {report.reporter_name}</p>}
            {report.reporter_email && <p><strong>Email:</strong> {report.reporter_email}</p>}
            {report.reporter_phone && <p><strong>Telefone:</strong> {report.reporter_phone}</p>}
          </div>
        )}
        {report.notification_email && !report.is_anonymous && (
          <p className="text-sm text-slate-500 mt-2">
            <strong>Email notificações:</strong> {report.notification_email}
          </p>
        )}
      </CardContent>
    </Card>

    <Card>
      <CardHeader>
        <CardTitle>Informação</CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <p><strong>Criada:</strong> {formatDate(report.created_at)}</p>
        {report.closed_at && <p><strong>Encerrada:</strong> {formatDate(report.closed_at)}</p>}
        <p><strong>ID:</strong> <code className="text-xs">{report.id}</code></p>
      </CardContent>
    </Card>
  </>
);
